/* eslint-disable jsx-a11y/media-has-caption */
import usePersistUser from '@modules/core/hooks/usePersistUser';
import {
  Box, Flex, Text
} from '@huspy/briks-web';
import MainContentPageWrapper from '@components/v2/MainContentPageWrapper';
import { NotFoundComponent } from '@modules/core/components/NotFoundComponent';
import { IS_SPAIN_ENV } from '@modules/core/utils';
import { useTranslation } from 'react-i18next';
import briksTheme from '@shared/briks-theme';
import { imagesPath } from '@shared/css.const';

const Video = ({
  url,
  thumbnail,
  index,
}: {
  url: string;
  thumbnail: string;
  index: number;
}) => (
  <video
    width='100%'
    height='315'
    controls
    style={ {
      borderRadius: briksTheme.spacing[4],
      height: '315px',
      objectFit: 'cover',
    } }
    poster={ thumbnail }
  >
    <source src={ url } type='video/mp4' data-testid={ `video-source-${index}` } />
  </video>
);

export const Tutorials = () => {
  const { user } = usePersistUser();
  const { t } = useTranslation();

  if (IS_SPAIN_ENV) {
    return <NotFoundComponent />;
  }

  if (!user) {
    return <></>;
  }

  return (
    <MainContentPageWrapper
      title={ t('tutorials.title') }
      subtitle={ t('tutorials.subtitle') }
    >
      <Flex
        direction='row'
        w='100%'
        gap='6'
        justify='space-between'
        wrap='wrap'
      >
        <Flex direction='column' gap='2' w='48%'>
          <Video
            index={ 0 }
            url='https://prod-brokers-portal.s3.eu-central-1.amazonaws.com/BROKER_PORTAL_video3_241107.mp4'
            thumbnail={ `${imagesPath}/portal-ux-thumbnail.png` }
          />
          <Box>
            <Text size='xl'>{t('tutorials.video1.title')}</Text>
            <Text size='lg' color='neutral.500'>
              {t('tutorials.video1.subtitle')}
            </Text>
          </Box>
        </Flex>
        <Flex direction='column' gap='2' w='48%'>
          <Video
            index={ 1 }
            url='https://prod-brokers-portal.s3.eu-central-1.amazonaws.com/BROKER_PORTAL_CREDITS_241107.mp4'
            thumbnail={ `${imagesPath}/credit-thumbnail.png` }
          />
          <Box>
            <Text size='xl'>{t('tutorials.video2.title')}</Text>
            <Text size='lg' color='neutral.500'>
              {t('tutorials.video2.subtitle')}
            </Text>
          </Box>
        </Flex>
        <Flex direction='column' gap='2' w='48%'>
          <Video
            index={ 2 }
            url='https://prod-brokers-portal.s3.eu-central-1.amazonaws.com/BROKER_PORTAL_video4_241107.mp4'
            thumbnail={ `${imagesPath}/proposal-thumbnail.png` }
          />
          <Box>
            <Text size='xl'>{t('tutorials.video3.title')}</Text>
            <Text size='lg' color='neutral.500'>
              {t('tutorials.video3.subtitle')}
            </Text>
          </Box>
        </Flex>
      </Flex>
    </MainContentPageWrapper>
  );
};
